// extracted by mini-css-extract-plugin
export default {"controls":"Controls_controls--f17","control":"Controls_control--aYG"};